import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

export type DeviceBadgeState = 'unassigned' | 'unavailable';

const stateConfig: Record<
  DeviceBadgeState,
  { label: string; route: string[]; buttonClass: string; ariaLabel: string }
> = {
  unassigned: {
    label: 'Unassigned',
    route: ['/devices', 'unassigned'],
    buttonClass: 'btn btn-warning btn-sm rounded-pill shadow-sm text-white fw-bold ps-2 ps-xs-3 border-0',
    ariaLabel: 'unassigned devices',
  },
  unavailable: {
    label: 'Unavailable',
    route: ['/devices', 'unavailable'],
    buttonClass: 'btn btn-danger btn-sm rounded-pill ms-2 shadow-sm fw-bold ps-2 ps-xs-3 border-0',
    ariaLabel: 'unavailable devices',
  },
};

@Component({
  selector: 'era-devices-state-badge-ui',
  templateUrl: './devices-state-badge.component.html',
  imports: [RouterLink],
})
export class DevicesStateBadgeComponent {
  readonly count = input.required<number>();
  readonly state = input.required<DeviceBadgeState>();

  get config() {
    const state = this.state();
    return state ? stateConfig[state] : null;
  }
}
